import { apiGet, apiPost } from '@/utils/request'
import { EP } from './endpoints'

export interface SystemRelease {
  id?: string
  release_version: string
  environment: string
  backend_image?: string
  frontend_image?: string
  git_commit?: string
  release_notes?: string
  created_by?: string
  current: boolean
  created_at?: string
}

export interface SystemReleaseCreateRequest {
  release_version: string
  environment: string
  backend_image?: string
  frontend_image?: string
  git_commit?: string
  release_notes?: string
}

export const getCurrentRelease = () =>
  apiGet<SystemRelease>(EP.console.currentRelease, { timeout: 10_000, silent: true })

export const createRelease = (data: SystemReleaseCreateRequest) =>
  apiPost<SystemRelease>(EP.console.releases, data)
